const PromotionPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">
      Current Promotions
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-purple-50 p-6 rounded-lg shadow-md border border-purple-200">
        <h3 className="text-2xl font-semibold text-purple-700 mb-3">
          New Member Special!
        </h3>
        <p className="text-gray-700 mb-4">
          Sign up for any 3-month yoga package and get your first month 50% off!
        </p>
        <p className="text-sm text-gray-600">
          Valid for new members only. Limited time offer.
        </p>
      </div>
      <div className="bg-indigo-50 p-6 rounded-lg shadow-md border border-indigo-200">
        <h3 className="text-2xl font-semibold text-indigo-700 mb-3">
          Refer a Friend & Save!
        </h3>
        <p className="text-gray-700 mb-4">
          Refer a friend who signs up for a package, and both of you receive a
          free yoga mat!
        </p>
        <p className="text-sm text-gray-600">
          Friend must mention your name upon registration.
        </p>
      </div>
    </div>
    <div className="mt-8 text-center">
      <p className="text-lg text-gray-700">
        Don't miss out on these amazing deals to start or continue your yoga
        journey!
      </p>
    </div>
  </div>
);

export default PromotionPage;
